module.exports = __webpack_public_path__ + "static/partner-icon-c8de2441dbe2b8ce8c8899d66ead5f24.svg";